export default __webpack_public_path__ + "static/media/ana-paula-xongani.235059e2.png";